import { ErrorInfo } from 'react'
// import RaygunClient, { ErrorType } from '../../services/raygun'

export default function handleAPIError(error: Error, info: ErrorInfo) {
  console.error(error, info)
  // TODO Using raygun
  // RaygunClient.getInstance().trackError(error, { type: ErrorType.API_ERROR, data: { info, user } })
}
